import { uniq } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ProductionComponentInstanceStatus } from '@paragon/contract-library';

import { RootState } from '../index';

export const getStatusesByBundleGuid = createSelector(
  (state: RootState) => state.productionModels.orderedBundlesByScheduleLineGroupGuid,
  (state: RootState) => state.productionModels.orderedProductionComponentInstancesByBundleGuid,

  (orderedBundlesByScheduleLineGroupGuid, orderedProductionComponentInstancesByBundleGuid) =>
    Object.values(orderedBundlesByScheduleLineGroupGuid)
      .flatMap((bundles) => bundles)
      .reduce(
        (statusByBundleGuid, bundle) => {
          statusByBundleGuid[bundle.guid] = uniq(
            orderedProductionComponentInstancesByBundleGuid[bundle.guid].map((instance) => instance.status),
          );
          return statusByBundleGuid;
        },
        {} as { [bundleGuid: string]: readonly ProductionComponentInstanceStatus[] },
      ),
);
